import { createDispatchHook } from "react-redux";
import { StoreContext } from "../../../../app/store.js";
const useAppDispatch = createDispatchHook(StoreContext).withTypes();
export {
  useAppDispatch
};
